import { baseApi } from "configs/store-query";
import {
  AuthenticationPasswordSignInApiRequest,
  AuthenticationPasswordSignInApiResponse,
  AuthenticationPasswordSignUpApiRequest,
  AuthenticationPasswordSignUpApiResponse,
} from "apis/authentication/types/authentication-password-api";

const BASE_PATH = "/authentication/password";

export const authenticationPasswordApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    signInPasswordAuthentication: build.mutation<
      AuthenticationPasswordSignInApiResponse,
      AuthenticationPasswordSignInApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/sign-in`,
        method: "POST",
        ...config,
      }),
    }),
    signUpPasswordAuthentication: build.mutation<
      AuthenticationPasswordSignUpApiResponse,
      AuthenticationPasswordSignUpApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/sign-up`,
        method: "POST",
        ...config,
      }),
    }),
  }),
});
